import { SURF_APP_ID } from "../constants.js";
export class SurfGraphQLError extends Error {
    errorType;
    constructor(message, opts) {
        super(message);
        this.name = "SurfGraphQLError";
        this.errorType = opts?.errorType;
    }
}
export function surfGraphQLHeaders(idToken) {
    return {
        "Content-Type": "application/json",
        Authorization: idToken,
        "X-Vida-AppId": SURF_APP_ID,
    };
}
export async function surfGraphQLFetch(opts) {
    const endpoint = opts.endpoint.trim();
    if (!endpoint)
        throw new SurfGraphQLError("Endpoint GraphQL mancante.");
    const res = await fetch(endpoint, {
        method: "POST",
        headers: surfGraphQLHeaders(opts.idToken),
        body: JSON.stringify({
            query: opts.query,
            variables: opts.variables ?? {},
        }),
    });
    const text = await res.text();
    if (!res.ok) {
        throw new SurfGraphQLError(`HTTP ${res.status}: ${text.slice(0, 400)}`);
    }
    let json;
    try {
        json = JSON.parse(text);
    }
    catch {
        throw new SurfGraphQLError("Risposta non JSON");
    }
    const errors = json.errors;
    if (errors?.length) {
        const first = errors[0];
        throw new SurfGraphQLError(first.message ?? "Errore GraphQL", {
            errorType: first.errorType,
        });
    }
    const data = json.data;
    if (!data || !(opts.resultKey in data)) {
        throw new SurfGraphQLError(`Campo mancante: ${opts.resultKey}`);
    }
    return data[opts.resultKey];
}
export function graphqlHostFromEndpoint(endpoint) {
    try {
        return new URL(endpoint).host;
    }
    catch {
        return endpoint.replace(/^https?:\/\//, "").replace(/\/.*$/, "");
    }
}
export function normalizeRealtimeWsUrl(endpoint) {
    let url = endpoint.trim().replace(/\/$/, "");
    if (url.startsWith("https://")) {
        url = `wss://${url.slice("https://".length)}`;
    }
    else if (url.startsWith("http://")) {
        url = `ws://${url.slice("http://".length)}`;
    }
    else if (!url.startsWith("wss://") && !url.startsWith("ws://")) {
        url = `wss://${url.replace(/^\/\//, "")}`;
    }
    if (!url.endsWith("/graphql")) {
        url = `${url}/graphql`;
    }
    return url;
}
export function realtimeEndpointFromGraphQL(graphqlEndpoint) {
    const trimmed = graphqlEndpoint.trim();
    if (trimmed.includes("appsync-realtime-api")) {
        return normalizeRealtimeWsUrl(trimmed);
    }
    return normalizeRealtimeWsUrl(trimmed.replace("appsync-api", "appsync-realtime-api"));
}
